export const CLIENT_URL = process.env.REACT_APP_CLIENT_URL || 'https://yim.uz';

export const SERVER_URL = `${process.env.REACT_APP_SERVER_URL}`;
export const API_URL = `${process.env.REACT_APP_SERVER_URL}/api/v1/`;

export const DEFAULT_LANGUAGE = localStorage.getItem('lang') || 'uz';
